/** Tooltip copy for list screens and training create dialog — presentation only. */

export const TRAINING_LIST_FIELD_HELP = {
  overallCompletion: 'Share of active training programs currently in progress across your organization.',
  mandatoryDue: 'Mandatory programs approaching their completion deadline.',
  overdueLearners: 'Learners who have not completed mandatory training past the due date.',
  programsActive: 'Training programs currently visible and accessible to learners.',
  audience: 'Course this training program is linked to.',
  completion: 'Cohort completion progress for this program.',
  due: 'Target completion date — learners past this date may be marked overdue.',
  type: 'Mandatory programs require completion; optional programs are voluntary.',
  status: 'In progress, overdue, or complete based on schedule and learner activity.',
};

export const TRAINING_DIALOG_FIELD_HELP = {
  scormMode: 'SCORM mode uploads a packaged course; standard mode generates AI video scripts and quizzes.',
  domains: 'Content domains from the linked course — questions are generated per domain.',
  subdomains: 'Sub-areas within selected domains for targeted question generation.',
  questionsPerVideo: 'How many quiz questions Yaki generates for each training video segment.',
  numberOfCharacters: 'Number of AI presenter characters in the generated training script.',
  gender: 'Gender profile for AI-generated presenter voices and visuals.',
  race: 'Presenter demographic used for AI-generated training characters.',
  language: 'Language for generated script and quiz content.',
  videoLength: 'Target length in minutes for each generated training video.',
  createFinalExam: 'Automatically creates a final assessment when this training is saved.',
};

export const ENROLLMENT_LIST_FIELD_HELP = {
  inviteAccepted: 'Whether the learner verified their email and accepted the enrollment invite.',
  status: 'Active enrollees can access the course; inactive enrollees are blocked.',
};

export const COURSE_LIST_FIELD_HELP = {
  status: 'Enabled courses are visible to learners; disabled courses are hidden regardless of schedule.',
};

export const COURSE_DETAIL_TRAINING_TABLE_HELP = {
  due: 'Date by which learners should complete this training.',
  completion: 'Enrolled learners who have completed this training, out of everyone enrolled in the course.',
  domains: 'Number of content domains covered in this training program.',
  questions: 'Total quiz questions linked to this training.',
  status: 'Active trainings are visible to learners; inactive trainings are hidden.',
};

export const TRAINING_QUESTION_LIST_FIELD_HELP = {
  questionType: 'Question format — for example multiple choice or text-based.',
  status: 'Approved questions appear in the training quiz; disapproved questions are excluded.',
};
